export const staircaseConfig = {
    gameSlug: 'color-match',
    category: 'foudre_logique',
    variable: 'duration_ms',
    startValue: 1500,
    minValue: 400,
    maxValue: 2500,
    stepSizesByPhase: [200, 100, 50, 25],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    // MVP : 30 essais max, < 3 min test live.
    maxTrials: 30,
    direction: 'down-easier',
};
export const COLORS = ['rouge', 'bleu', 'vert', 'jaune'];
export const COLOR_HEX = {
    rouge: '#c64a3f',
    bleu: '#3a72b8',
    vert: '#5b8c5a',
    jaune: '#d4a93a',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, incongruentRate: 0.3, nColors: 4, label: 'Stroop classique' };
    }
    if (level <= 20) {
        return { level, incongruentRate: 0.5, nColors: 4, label: 'Conflit fréquent' };
    }
    if (level <= 30) {
        return { level, incongruentRate: 0.65, nColors: 6, label: 'Inhibition forte' };
    }
    if (level <= 40) {
        return { level, incongruentRate: 0.75, nColors: 6, label: 'Match serré' };
    }
    return { level, incongruentRate: 0.8, nColors: 8, label: 'Reverse mode' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 400,
    feedbackMs: 500,
    itiMs: 600,
    minRenderMs: 200,
};
export const paradigmMeta = {
    slug: 'color-match',
    paradigm: 'Stroop matching task (Stroop 1935 / MacLeod 1991)',
    masterMage: 'Ondine (eau-mémoire) — variante inhibition cognitive',
    category: 'foudre_logique',
    goal: 'Inhiber la lecture automatique pour comparer encre vs sens.',
};
//# sourceMappingURL=params.js.map